<div class="toolbar rounded-pill p-2 medium-shadow" *ngIf="selection" [ngClass]="showSelected ? 'mt-2' : ''">
    <div class="d-flex flex-row">
        <div class="mr-2">{{ 'TABLE.NUMBER_SELECTED' | translate: { numberSelected: selection.length } }}</div>
        <ng-container *ngFor="let btn of toolbarConfig.buttons">
            <div class="divider" style="color: var(--primary-color-text)"></div>
            <button class="toolbar-btn" [ngClass]="{ disabled: btn.enabled ? !btn.enabled(selection.length) : false }" (click)="btn.method(selection)">
                {{ btn.title | translate }}
            </button>
        </ng-container>
        <div class="divider" style="color: var(--primary-color-text)"></div>
        <button class="toolbar-btn" [ngClass]="selection.length < 1 ? 'disabled' : ''" [disabled]="selection.length < 1" (click)="toolbarConfig.showSelection()">
            <span *ngIf="showSelected">{{ 'TABLE.SHOW_ALL' | translate }}</span>
            <span *ngIf="!showSelected">{{ 'TABLE.SHOW_SELECTED' | translate }}</span>
        </button>
        <div class="divider" style="color: var(--primary-color-text)"></div>
        <button class="toolbar-btn" (click)="toolbarConfig.clearSelection()" [ngClass]="selection.length < 1 ? 'disabled' : ''" [disabled]="selection.length < 1">
            {{ 'TABLE.CLEAR_SELECTION' | translate }}
        </button>
    </div>
</div>
